import PropTypes from 'prop-types';
import {
  Typography,
  Card,
  Box,
  CardContent,
  CardMedia,
  Divider,
  Chip,
} from '@material-ui/core';
import {red} from '@material-ui/core/colors';
import Media from 'SbsSuite/Presentation/Media';
import {useStyles} from 'Utility/styles';

export default function ScheduleStep(props) {
  const classes = useStyles();
  const {
    selectedStep: {step},
  } = props;

  return (
    <Card className={classes.rootStep}>
      {step && (
        <div className={classes.detailsStep}>
          <Box>
            <CardContent className={classes.contentStep}>
              {step.hh + step.mm + step.ss > 0 ? (
                <Typography
                  variant="h6"
                  style={{marginRight: 8, opacity: 0.54}}
                >
                  {`${step.hh}h ${step.mm}m ${step.ss}s`}
                </Typography>
              ) : (
                <Chip
                  label="Time?"
                  style={{backgroundColor: red['500'], marginRight: 8}}
                />
              )}
              <Typography variant="h6" style={{opacity: 0.54}}>
                {/* {step.stepLevel.level} */}
              </Typography>
              <Typography variant="h6">Instruction</Typography>
              <Typography
                dangerouslySetInnerHTML={{
                  __html: step.instruction.replace(/<\/p><p>/g, '<br>'),
                }}
              />
              {step.detail !== '<br />' && step.detail !== '<br>' && (
                <>
                  <Divider
                    variant="fullWidth"
                    style={{marginTop: 10, marginBottom: 10}}
                  />
                  <Typography variant="h6">Detail</Typography>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: step.detail.replace(/<\/p><p>/g, '<br>'),
                    }}
                  />
                </>
              )}
            </CardContent>
          </Box>
          <CardMedia className={classes.coverStep}>
            <Box>
              <Media media={step.media} />
            </Box>
          </CardMedia>
        </div>
      )}
    </Card>
  );
}

ScheduleStep.propTypes = {
  selectedStep: PropTypes.shape({
    id: PropTypes.string,
    sortorder: PropTypes.number,
    step: PropTypes.shape({
      instruction: PropTypes.string,
      detail: PropTypes.string,
      media: PropTypes.shape({
        id: PropTypes.string,
        image: PropTypes.bool,
        length: PropTypes.number,
        mime: PropTypes.string,
        s3key: PropTypes.string,
        url: PropTypes.string,
      }),
      hh: PropTypes.number,
      mm: PropTypes.number,
      ss: PropTypes.number,
    }),
  }).isRequired,
};
